import { createSlice } from "@reduxjs/toolkit";
import {
  fetchIndices,
  fetchIndexDetails,
  fetchIndexPrices,
  fetchIndexMetrics,
  refreshIndexPrices,
} from "./nasdaqIndexActions";

const initialState = {
  indices: [],
  indicesStatus: "idle",
  indicesError: null,

  indexDetails: {},
  indexDetailsStatus: "idle",
  indexDetailsError: null,

  indexPrices: {},
  indexPricesStatus: "idle",
  indexPricesError: null,

  indexMetrics: {},
  indexMetricsStatus: "idle",
  indexMetricsError: null,

  refreshStatus: "idle",
  refreshError: null,
};

const indexSlice = createSlice({
  name: "indices",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Indices list
      .addCase(fetchIndices.pending, (state) => {
        state.indicesStatus = "loading";
      })
      .addCase(fetchIndices.fulfilled, (state, action) => {
        state.indicesStatus = "succeeded";
        state.indices = action.payload;
      })
      .addCase(fetchIndices.rejected, (state, action) => {
        state.indicesStatus = "failed";
        state.indicesError = action.payload;
      })

      // Index details
      .addCase(fetchIndexDetails.pending, (state) => {
        state.indexDetailsStatus = "loading";
      })
      .addCase(fetchIndexDetails.fulfilled, (state, action) => {
        state.indexDetailsStatus = "succeeded";
        state.indexDetails[action.meta.arg] = action.payload;
      })
      .addCase(fetchIndexDetails.rejected, (state, action) => {
        state.indexDetailsStatus = "failed";
        state.indexDetailsError = action.payload;
      })

      // Index prices
      .addCase(fetchIndexPrices.pending, (state) => {
        state.indexPricesStatus = "loading";
      })
      .addCase(fetchIndexPrices.fulfilled, (state, action) => {
        const { ticker } = action.meta.arg;
        state.indexPricesStatus = "succeeded";
        state.indexPrices[ticker] = action.payload;
      })
      .addCase(fetchIndexPrices.rejected, (state, action) => {
        state.indexPricesStatus = "failed";
        state.indexPricesError = action.payload;
      })

      // Index metrics
      .addCase(fetchIndexMetrics.pending, (state) => {
        state.indexMetricsStatus = "loading";
      })
      .addCase(fetchIndexMetrics.fulfilled, (state, action) => {
        state.indexMetricsStatus = "succeeded";
        state.indexMetrics[action.meta.arg] = action.payload;
      })
      .addCase(fetchIndexMetrics.rejected, (state, action) => {
        state.indexMetricsStatus = "failed";
        state.indexMetricsError = action.payload;
      })

      // Refresh prices
      .addCase(refreshIndexPrices.pending, (state) => {
        state.refreshStatus = "loading";
      })
      .addCase(refreshIndexPrices.fulfilled, (state) => {
        state.refreshStatus = "succeeded";
        state.refreshError = null;
      })
      .addCase(refreshIndexPrices.rejected, (state, action) => {
        state.refreshStatus = "failed";
        state.refreshError = action.payload;
      });
  },
});

export default indexSlice.reducer;
